<template>
  <div class="platform-info-edit-wrp ft-12">
    <div v-loading="loading" class="tb-form">
      <slot name="errMsg"></slot>
      <Form
        ref="form"
        :baseItemId="form.baseItemId"
        :formSections="formSections"
        :defaultData="formData"
        :auditFileList="auditFileList"
        :priceList="priceList"
        :showAuditResult="true"
        :openSource="openSource"
        :shopList="shopList"
        @fieldChanged="specificationsFieldChanged"
        @file-upload="handleImageUpload"
        @fixedPrice="fixedPriceGet"
        @fixedPriceCheck="fixedPriceCheck"
        >
         <template v-slot:shipShelf> 
            <!-- 运费模板 -->
              <section>
                <div class="title ft-12">
                  <span>运费模板</span>
                </div>
                <div class="conf">
                  <el-form-item label="运费设置：">
                    <el-row  v-if="shopList.length && shipsValue">
                      <el-col v-for="shop in shopList" :key="shop.id" :span="12" class="set-ship">
                        <el-image
                          :src="shop.icon"
                          style="width: 26px; height: 26px;  border-radius: 50%"
                          ></el-image>
                        <el-tooltip v-if="shop.channelIcon" :content="shop.channelName" style="margin: 0px -6px 0px 6px;">
                          <el-image :src="shop.channelIcon" style="width: 18px; height: 18px;"></el-image>
                        </el-tooltip>
                          <span class="shop-title">{{ shop.shortTitle || shop.title}}</span>
                          <el-select 
                            v-model="shipsValue[shop.id]" 
                            placeholder="请选择运费模板"
                            :value-key="String(shop.id)"
                            clearable
                            @visible-change="isVisible => changeSelect(isVisible, shop)"
                            @change="shipsChanged($event, shop.id,  shop.userId)"
                            >
                            <el-option
                              v-for="ship in shipsTemplate[shop.id]"
                              :key="ship.id"
                              :label="ship.name"
                              :value="ship.id"
                              >
                            </el-option>
                          </el-select>
                      </el-col>
                    </el-row>
                    <span v-else class="no-shops">暂无平台店铺</span>
                  </el-form-item>
                </div>
              </section>
              <!-- 上架设置 -->
              <!-- <section>
                <div class="title ft-12">
                  <span>上架设置</span>
                </div>
                <div class="conf">
                  <el-form-item 
                    label="上架设置:" 
                    :rules="[{required: true, message: '请输入上架设置', trigger: 'blur'}]">
                      <el-radio-group v-model="isOnshelf">
                          <el-radio :label="1">立即上架</el-radio>
                          <el-radio :label="2">放入草稿箱</el-radio>
                      </el-radio-group>
                  </el-form-item>
                </div>
              </section> -->
          </template>
        </Form>
    </div>
  </div>
</template>

<script>
import { getForm, getItemPublishSchemaPropV2, getTbDetail } from '@/servers/prod/center/tb';
import Form from './components/Form/Form.vue';
import { generateSections } from './utils/sections';
import { form2data, dataDefaultValue, formatFormData, merge_fieldDescriptorList,getImagesSizes } from './utils/data' 
import {getDistributionConfig, getTBTemplateList} from '@servers/prod/conf/index.js'
import { getTaobaoFreightTemplate, uploadImageToPlatform, queryPlatFormImagesStatus } from '@api/prod/conf/index.js'

import { mapActions, mapGetters, mapState } from 'vuex';
import _, { cloneDeep, isEmpty, keyBy } from 'lodash'
import validateMixin from '../validateMixin';
import shopListMixin from '../shopListMixin';

export default {
  components: { Form },
  mixins: [validateMixin, shopListMixin],
  provide() {
    return {
      tbFormVm: this,
      openSource:this.openSource
    }
  },
  inject: {
    isGroupPuhuo: { default: false },
  },
  props: {
    form: {
      type: Object | Array,
      default() {
        return {};
      },
    },
    shopsList: {
      type: Array,
      default: ()=> {
          return []
      }
    },
    changeToBase: {
      type: Function,
      default() {
        return () => {}
      }
    },
    rowData: {
      type: Object,
      default: () => ({})
    },
    openSource:{
      type:String,
      default:''
    },
  },
  watch: {
    form: {
      async handler(data, o) {
      if (isEmpty(data)) return
        const v = cloneDeep(data)
        this.clearTbInfo()
        if(!v.specifications?.length || !v.skuList?.length) {
          const resV2 = await getTbDetail({baseItemId: v.baseItemId, pureType: 0 })
          v.specifications = resV2.specifications || []
          v.skuList = resV2.skuList || []
        }

        const { categoryIds } = v;
        v.detailHasCategory = v.categoryIds
        if (categoryIds && categoryIds.length) {
          if(v.skuFix && !v.pureType) {
            this.$message.warning('有未匹配的规格明细，当前商品规格是从基础资料同步的数据，保存后生效');
          }
        }
        this.initTbForm(v);
        this.initTbOriData(v)
        // 保存原始 templateConfig，用于保存时恢复未显示店铺的数据
        if (v.templateConfig && v.templateConfig.length) {
          this.originalTemplateConfig = cloneDeep(v.templateConfig);
        }
        this.self_form = v;
        this.getConf();
        this.updateTbIsNew(!!v.newWirelessDesc);
        this.$nextTick(() => {
          this.$refs.form.$refs.form.validate();
        })
      },
      immediate: true,
      deep: true
    },
    templateConfigMap: {
      handler(newVal) {
        this.resetFormSections();
      },
      immediate: true,
      deep: true
    },
    'tbForm.categoryIds': {
      handler(newVal, oldVal) {
        if ((newVal || []).join(',') !== (oldVal || []).join(',')) {
          this.getPlatFormImagesStatus();
          this.categoryId = newVal.length ? newVal[newVal.length - 1] : ''
          this.getUiData()
        }
      },
      immediate: true,
    },
    'tbForm.deliveryTimeSetBySku': {
      handler(newVal, oldVal) {
        if(!newVal) return
        const val = Number(newVal)
        const tbDeliveryTimeForm = this.formSections?.find(item => item.title === '销售信息')?.children?.find(item => item.name === "tbDeliveryTime")
        if(tbDeliveryTimeForm) {
          tbDeliveryTimeForm.component.props.disabled = !!val
          if(val) {
            this.updateTbForm({tbDeliveryTime: ''})
            tbDeliveryTimeForm.rules = []
          } else {
            tbDeliveryTimeForm.rules = [
                {
                    required: true,
                    message: '必填'
                }
            ]
          }
        }
      },
    },
    'tbForm.pureType': {
      handler(newVal, oldVal) {
        this.pureTypeHandle()
      }
    },
  },
  data() {
    return {
      formKey: 'tbForm',
      categoryId: '',
      catPropSecondaryList: [],
      pureTypeDisabled: false,
      active: 2,
      self_form: {},
      schemas: {},
      rules: [],
      baseInfo: {},
      formSections: [],
      formData: {},
      loading: false,
      shipsTemplate: {}, // 运费模板列表
      shipsValue: null, // 运费模板值，{shopId: templateId}
      templateConfigMap: {}, // 运费模板配置map
      originalTemplateConfig: null, // 原始运费模板配置（用于保存时恢复未显示店铺的数据）
      // isOnshelf: 1,
      auditFileList: [],
      priceList:[], // sku价格列表
      priceCheck: false, // 一口价强制校验,
      schemaPropV2: []
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'tbForm', 'tbData', 'shops_defaultShopId', 'shops_getCategoryPropShopId', 'tbIsNew']),
    shopList() {
      let list = this.getShopList('tb');
      if(this.openSource === 'shopGoods'){
          list = list.filter(item => item.id == this.form.shopId)
      }
      return list;
    },
  },
  methods: {
    ...mapActions(['initTbForm', 'initTbData', 'initTbOriData', 'clearTbInfo', 'clearTbForm_PData', 'updateCatePropShopIndex', 'updateTbForm', 'clearTbFormSome', 'initTbSecondary', 'updateTbIsNew']),
    resetFormSections() {
      if(!this.shipsValue) return
      const newVal = this.templateConfigMap;
      const shipKeys = Object.keys(this.shipsValue)
      const formSections = this.formSections
      let needRequired = false;
      for (let i = 0; i < shipKeys.length; i++) {
        const userId = shipKeys[i]
        const shopUserId = this.shipsValue[userId];
        if (shopUserId && newVal[userId]?.valuation === 1) {
          needRequired = true;
          break;
        }
      }
      if (formSections.length > 0) {
        this.formSections[1].children.map(item => {
          if (item.name === 'deliverWeight') {
            item.rules = [{ required: needRequired, message: '运费模板为重量模板时，重量为必填项'}]
          }
          return item;
        });
      }
    },
    pureTypeHandle() {
      const hasSaleProp = !!this.schemas.saleProp?.children?.length
      if(!hasSaleProp) {
        this.updateTbForm({ pureType: 1 })
      } else {
        const properties = this.schemas.saleProp.properties
        if(properties?.length) {
          const ismatch = properties.find(p => p.key === 'isWithoutPair' && p.value === 'true')
          if(ismatch) {
            if(this.tbForm.pureType === 1) {
              this.updateTbForm({ pureType: 0 })
            }
          } 
          this.pureTypeDisabled = !!ismatch
        }
      }
      const fn = (children = []) => {
        children.forEach(item => {
          if(item.name === "quantity") {
            item.component.props.disabled = !this.tbForm.pureType && hasSaleProp;
          } else if (item.children?.length) {
            fn(item.children);
          }
        });
      };
      this.formSections.forEach(section => {
        fn(section.children);
      });
    },
    handleImageUpload(picUrl) {
      const { categoryIds = [] } = this.tbForm;
      const categoryIdNeedValidImage = categoryIds.some(item => {
        return [2813, '2813'].includes(item);
      });
      if (!categoryIdNeedValidImage) {
        return false;
      }
      const shopInfoList = this.shopList.filter(item=> {
        return item.state === 2 || item.state === 3
      }).map(item => {
        const { id, taobaoId } = item;
        return {
          shopId: id,
          taobaoId
        }
      });
      const { companyId } = this.userInfo;
      const { baseItemId } = this.form;
      const requestParams = {
        baseItemId,
        companyId,
        platformType: 'tb',
        shopInfoList,
        picUrl
      }
      uploadImageToPlatform(requestParams).then(() => {
        // this.getPlatFormImagesStatus();
      })
    },
    getPlatFormImagesStatus() {
      const { companyId } = this.userInfo;
      const { baseItemId } = this.form;
      if (!baseItemId) {
        return false;
      }
      const { categoryIds = [] } = this.tbForm;
      const categoryIdNeedValidImage = categoryIds.some(item => {
        return [2813, '2813'].includes(item);
      });
      if (!categoryIdNeedValidImage) {
        this.auditFileList = [];
        return false;
      }
      
      const shopInfoList = this.shopList.filter(item=> {
        return item.state === 2 || item.state === 3
      }).map(item => {
        const { id, taobaoId } = item;
        return {
          shopId: id,
          taobaoId
        }
      });
      const requestParams = {
        baseItemId,
        companyId,
        platformType: 'tb',
        shopInfoList,
      };
      const shopDataMap = keyBy(this.shopList, 'taobaoId')
      queryPlatFormImagesStatus(requestParams).then((res) => {
        this.auditFileList = (res.data || []).filter(item => {
          return item.auditStatus !== 102;
        }).map(item => {
          const matchItem = shopDataMap[item.shopId];
          item.shopName = matchItem ? (matchItem.title || matchItem.priorityTitle) : '';
          return item;
        })
      });
    },
    getSecondaryUI(first) {
      if (!this.categoryId) return
      const fieldDescriptorList = formatFormData(this.tbForm, this.formSections)
      const catPropField = fieldDescriptorList.find(item => item.name === "catProp")
      getItemPublishSchemaPropV2({
        fieldDescriptor: catPropField,
        shopId: this.shops_getCategoryPropShopId('tb'),
        catId: this.categoryId,
        propId: '20000'
      }).then(res => {
        if(this.isSameSchemaPropV2(res, this.schemaPropV2)) {
          return
        }
        this.schemaPropV2 = res || []
        let newSecondaryProps = {}
        res.forEach(secondaryItem => {
          newSecondaryProps[secondaryItem.name] = secondaryItem
        });
        this.method_updateCatPropSecondary(newSecondaryProps, first)
      })
    },
    // 单独更新类目属性字段 --- 次级属性
    method_updateCatPropSecondary(newCatPropSchema, first) {
      // 生成ui
      const { formSections } = generateSections(newCatPropSchema, {
        isUpdateCatPropSecondary: true,
        tbForm: this.tbForm
      })
      
      // 找到新的类目属性的children
      this.formSections = this.formSections.map(item => {
        const secondarySectionChildren = formSections.find(section => section.title === item.title)?.children || []
        const newChildren = item.children.map(fieldItem => {
          const index = secondarySectionChildren.findIndex(secondaryFieldItem => secondaryFieldItem.name === fieldItem.name); // 新的级联属性中是否有当前属性
          if (index > -1) {
            const updatedField = { ...secondarySectionChildren[index], isSecondary: true };
            secondarySectionChildren.splice(index, 1);
            return updatedField;
          }
          return fieldItem.isSecondary ? null : fieldItem;
        }).filter(Boolean);
        // 原form没有的，添加次级属性
        secondarySectionChildren.forEach(fieldItem => {
          newChildren.push({...fieldItem, isSecondary: true})
        })
        item.children = newChildren
        return item
      })
     
      if (first) {
        this.initTbSecondary(this.formSections);
        // 新的级联属性项和旧的级联属性项不同时，需要轮训调取类目属性，直至相同
        const catPropSecondaryList = this.formSections.reduce((acc, item) => {
          if (item?.children?.length) {
            const newCatPropChildren = item.children.find(child => child.name === 'catProp')?.children;
            if (newCatPropChildren) {
              const filteredChildren = newCatPropChildren.filter(child => /\[alibaba.item.publish.props.get\]/.test(child?._oriRules?.devTipRule));
              acc.push(...filteredChildren.map(child => ({ name: child.name, label: child.label})));
            }
          }
          return acc;
        }, []);
        if (this.hasNameDifference(catPropSecondaryList, this.catPropSecondaryList || [])) {
          this.$nextTick(() => {
            this.getSecondaryUI(true);
          });
        }
        this.catPropSecondaryList = catPropSecondaryList;
      }
    },
    hasNameDifference(newList, oldList) {
      const newNames = new Set(newList.map(item => item.name));
      const oldNames = new Set(oldList.map(item => item.name));
      return newNames.size !== oldNames.size || ![...newNames].every(name => oldNames.has(name));

    },
    // 对比前后两次的次级属性是否相同，相同就不必重新渲染，造成页面卡顿
    isSameSchemaPropV2(newProps, oldProps) {
      let newNames = this.getAllNames(newProps)
      let oldNames = this.getAllNames(oldProps)
      if(newNames.length === oldNames.length) {
        oldNames.forEach(oldName => {
          const findIndex = newNames.findIndex(newName => newName === oldName)
          if(findIndex > -1) {
            newNames.splice(findIndex, 1)
          }
        })
      }
      return newNames.length === 0
    },
    getAllNames(props=[]) {
      let names = []
      function getName(list) {
        list.forEach(item => {
          names.push(item.name)
          if(item.children?.length) {
            getName(item.children)
          }
        })
      }
      getName(props)
      return names
    },

    async getUiData() {
      const shopId = this.self_form.shopId || this.shops_defaultShopId('tb')
      if(!this.categoryId || !shopId) return
      window._tb_cutomId = -2 // 用于一些自定义下拉框的id生成
      this.loading = true;
      this.formSections = []
      const res = await getForm({
        shopId,
        baseItemId: '',
        catId: this.categoryId,
      });
      if (!res) {
        this.loading = false
        return false
      }
      // 需求 KMERP-263920 https://tb.raycloud.com/task/685917f443c33040d192bf70
      // 可能存在数据为 null 的情况
      if (res.images) {
        // 对 1:1主图 images 中 tipRule 做处理，tipRule是一个数组，直接更改数组中的内容, 并修改rules中的tipRule
        res.images.tipRule = ['比例为1:1，推荐尺寸1440x1440及以上，至多可上传5张']
        res.images.rules && (res.images.rules.tipRule = '比例为1:1，推荐尺寸1440x1440及以上，至多可上传5张')
      }
      if (res.threeToFourImages) {
        // 对 3:4主图 threeToFourImages 中 tipRule 做处理，同上
        res.threeToFourImages.tipRule = ['比例为3:4，推荐尺寸1440x1920及以上，至多可上传5张']
        res.threeToFourImages.rules && (res.threeToFourImages.rules.tipRule = '比例为3:4，推荐尺寸1440x1920及以上，至多可上传5张')
      }
      // 新版编辑器不会返回desc的发布规则，手动插入一条desc的发布规则
      if(!res.desc){
      // if(this.tbIsNew && !res.desc){
        res.desc = {
          children:null,
          dataId:null,
          defaultValue:null,
          extendValue:null,
          id:null,
          label: "PC端详情描述",
          name: "desc",
          options:null,
          propType:null,
          properties:[],
          rules:{valueTypeRule:'text'},
          type:'INPUT',
          valueDisplayName:null,
          valueType:null
        }
      }

      this.schemas = res
      // 动态表单
      const { formSections } = generateSections(res);
      let catPropSecondaryList = []
      this.formSections = formSections.filter(item => {
        if(item && item.children?.length) {
          const newCatPropChildren = item.children.find(item => item.name === 'catProp')?.children
          if(newCatPropChildren) {
            catPropSecondaryList = newCatPropChildren.filter(item => /\[alibaba.item.publish.props.get\]/.test(item?._oriRules?.devTipRule)).map(item => ({name: item.name, label: item.label}))
          }
          return true
        }
        return false
      });
      this.catPropSecondaryList = catPropSecondaryList
      this.resetFormSections();
      this.initTbData({
        data: dataDefaultValue(this.form),
        formSections: this.formSections
      });
      this.updateTbForm({
        showMode: res.customSaleProp && (this.self_form.specifications || []).every(item => item.nameKey && item.nameKey.startsWith('custom_')) ? 'single-custom' : 'multi-select'
      })
      this.pureTypeHandle()
      // !categoryNoChange && this.clearTbForm_PData()
      this.handleUI();
      this.loading = false;
      if(this.catPropSecondaryList.length) {
        this.getSecondaryUI(true)
      }
    },
    handleUI() {
      // return
        // “计量单位”选择为：
        // 1：每100毫升（value：hundredMilliliter）或每100克（value：hundredGram）时，children中的每份含量（name：partAmount）和营养成分表-计量单位（name：partUnit）置灰，不可填；
        // 2：每份（value：part）时，children中的每份含量（name：partAmount）和营养成分表-计量单位（name：partUnit）为必填
        
        const formSections = this.formSections
        const foodSections = formSections.find(item => item.title === '食品安全')?.children || []
        if(!foodSections.length) return
        const foodNutrition = foodSections.find(ui => ui.name === 'food_security.food_nutrition_table')
        if(foodNutrition) {
          const unit = this.tbForm.unit;
          const childrenList = foodNutrition.component.props.dataSource.children || [];
          if(unit === 'hundredMilliliter' || unit === 'hundredGram') {
            childrenList.forEach(item => {
              if(item.name === 'partAmount' || item.name === 'partUnit') {
                item.component.props.disabled = true;
                item.rules = [];
              } 
            })
            this.tbForm.partAmount = '';
            this.tbForm.partUnit = '';
          } else if(unit === 'part') {
            childrenList.forEach(item => {
              if(item.name === 'partAmount' || item.name === 'partUnit') {
                item.component.props.disabled = false;
                item.rules = [{required: true, message: "必填"}];
              } 
            })
          } else {
            childrenList.forEach(item => {
              if(item.name === 'partAmount' || item.name === 'partUnit') {
                item.component.props.disabled = false;
                item.rules = [];
              } 
            })
          }
        }
        //  选择有机食品为是时，有机证书编号为必填
        const foodOrganicCertification = foodSections.find(ui => ui.name === 'food_security.organic_certification')
        if(foodOrganicCertification) {
          const organic_food = this.tbForm['food_security.organic_food'];
          foodOrganicCertification.rules = organic_food == 1 ? [{required: true, message: "必填"}] : [];
        }

        // 选择绿色食品为是时，绿色食品等级为必填， 绿色产品编号为必填
        const green_food = this.tbForm['food_security.is_green_food'];
        const greenFoodLevel = foodSections.find(ui => ui.name === 'food_security.green_food_level')
        const greenFoodProduceNumber = foodSections.find(ui => ui.name === 'food_security.green_food_produce_number')
        if(greenFoodLevel) {
          greenFoodLevel.rules = green_food == 1 ? [{required: true, message: "必填"}] : [];
        }
        if(greenFoodProduceNumber) {
          greenFoodProduceNumber.rules = green_food == 1 ? [{required: true, message: "必填"}] : [];
        }
    },
     handleTemplateConfig() {
      const arr = [];
      Object.keys(this.shipsValue).forEach(key=> {
        this.shipsTemplate[key].forEach(item=> {
          if(item.id == this.shipsValue[key]){
            const channel = this.shopList.find(shop => shop.id == key)?.channel
            arr.push({
              shopId: key,
              templateId: item.id,
              templateName: item.name,
              valuation: item.valuation,
              channel
            })
          }
        })
      })
      return JSON.stringify(arr);
    },
    async valid_specifications() {
      return new Promise(async (resolve, reject) => {
        let specificationsValid = null;
        const saleProp = this.$refs.form.$refs.saleProp;
        if (saleProp) {
          specificationsValid = saleProp[0]?.validateSpecifications();
        } else {
          specificationsValid = true;
        }
        this.specificationsValidResult = specificationsValid;
        if (specificationsValid !== true) {
          resolve(false);
          return;
        }
        resolve(true);
      });
    },
    async valid_form() {
      return new Promise(async (resolve) => {
        if (!this.$refs.form) {
          resolve(false);
          return false;
        }
        const refForm = this.$refs.form.$refs.form;
        if (refForm) {
          setTimeout(() => {
            refForm.validate(valid => {
              resolve(valid);
            });
          }, 300)
        } else {
          resolve(false);
        }
      });
    },
    fixedPriceCheck(isCheck){
      this.priceCheck = isCheck;
    },
    async getFieldDescriptorList() {
      let fieldDescriptorList = merge_fieldDescriptorList(
        [...this.tbData.fieldDescriptorList],
        [...formatFormData(this.tbForm, this.formSections)]
      );
      let wirelessDesc = fieldDescriptorList.find(item => item.name === 'wirelessDesc');
      let urls = wirelessDesc ? wirelessDesc.children : null;
      // url 是个数组就是新版本编辑器，针对新版编辑器图片保存做一下处理
      let result = [];
      if(urls && urls.length){
        urls = await getImagesSizes(urls);
        let version = wirelessDesc.children.find(i => i.name === 'version');
        if(!version){
          version = {
            defaultValue:'1.0.0',
            name:'version',
            type:'INPUT',
          }
        }
        urls.forEach((cfg,i) => {
          let children = [
            {
              defaultValue:'true',
              name:'enable',
              type:'SINGLECHECK'
            },
            {
              children:[
                {
                  defaultValue:cfg.url,
                  name:'url',
                  type:'INPUT',
                },
                {
                  defaultValue:cfg.width || 0,
                  name:'width',
                  type:'INPUT',
                },
                {
                  defaultValue:cfg.height || 0,
                  name:'height',
                  type:'INPUT',
                }
              ],
              name:'image',
              type:'COMPLEX'
            }
          ]
          let obj = {
            children,
            name:`image_hot_area_${i}`,
            type:'COMPLEX'
          }
          result.push(obj)
        }); 
        result.unshift(version);
        wirelessDesc.children = result
      }
      return fieldDescriptorList
    },
    async method_getFormData() {
      return new Promise((resovle) => {
        if (!this.categoryId) {
          this.$message.error('请选择商品分类')
          resovle(false)
          return;
        }
        if(this.priceCheck){
          this.$message.error('一口价必须和任意规格的单价一致')
          resovle(false)
          return;
        }
        this.validPage().then(async(valid) => {
          if (!valid) {
            this.$message.error('请完善表单')
            resovle(false)
            return false;
          }
          const salePropRef = this.$refs.form.$refs.saleProp
          let salePropData = [];
          if(salePropRef && salePropRef.length) {
            salePropData = salePropRef[0].method_getData()
          } else {
            salePropData = [[], [], {}, 0];
          }
          const [specifications, skuList, sizeGroup, isGroup] = salePropData;
          let formData = form2data(this.tbForm, this.tbData)
          formData.fieldDescriptorList = await this.getFieldDescriptorList()
          formData.categoryId = this.categoryId
          formData.specifications = specifications
          formData.skuList = skuList
          formData.isGroup = isGroup
          formData.shopId = this.shops_getCategoryPropShopId('tb')
          console.log(cloneDeep(formData.fieldDescriptorList), formData, cloneDeep(this.tbForm),"----fieldDescriptorList, formData-this.tbForm-")
          // resovle(false)
          // return 
          resovle({...formData, templateConfig: (() => {
            let current = JSON.parse(this.handleTemplateConfig());
            current = this.mergeHiddenShopData(current, this.originalTemplateConfig, this.shopList);
            return JSON.stringify(current);
          })()})
        })
      })
      // 获取数据保存
      // return this.formData;
    },
    clear_specification() {
      this.$refs.form.$refs.saleProp && this.$refs.form.$refs.saleProp[0]?.clear_specification()
    },
    // 处理淘宝详情 templateConfig
    initTemplateConfig(templateList = []) {
      const ships = {};
      this.shopList.forEach((shop) => {
        ships[shop.id] = '';
      });
      const templateConfigMap = {};
      this.self_form.templateConfig =  this.self_form.templateConfig ? this.self_form.templateConfig : [];
      this.self_form.templateConfig.forEach(item => {
        if(this.openSource != 'shopGoods' || (this.openSource === 'shopGoods' && this.form.shopId == item.shopId)){ // 店铺商品只保留当前店铺数据
          templateConfigMap[item.shopId] = {
            templateId: item.templateId,
            templateName: item.templateName,
            valuation: item.valuation,
          };
        }
      });
      templateList.forEach(item => {
        if(this.openSource != 'shopGoods' || (this.openSource === 'shopGoods' && this.form.shopId == item.shopId)){ // 店铺商品只保留当前店铺数据
          if(!templateConfigMap[item.shopId]){
              templateConfigMap[item.shopId] = {
              templateId: item.templateId,
              templateName: item.templateName,
              valuation: item.valuation,
            };
          }
        }
      })
      Object.keys(templateConfigMap).forEach(key => {
        ships[key] = templateConfigMap[key].templateId
      })
     this.shipsValue = ships;
     this.initShipsTemplate(templateConfigMap);
     this.templateConfigMap = templateConfigMap;
     this.getShopTemplateValuation();
    },
    // 获取模板重量
    getShopTemplateValuation() {
      let shopIds = [];
      const templateConfig  = this.templateConfigMap;
      Object.keys(templateConfig).forEach(item => {
        const current = templateConfig[item]
        if (current.templateId && !current.valuation) {
          shopIds.push(item);
        }
      });
      if (shopIds.length === 0) return false;
      getTaobaoFreightTemplate({
        shopIdList: shopIds
      }).then((res) => {
        const { data = [] } = res;
        data.forEach(item => {
          const { shopId } = item;
          const matchItem = this.templateConfigMap[shopId]
          if (matchItem) {
            const { templateList = [] } = item;
            const templateMap = keyBy(templateList, 'templateId');
            const { templateId } = matchItem;
            const matchTemplate = templateMap[templateId];
            if (matchTemplate) {
              matchItem['valuation'] = matchTemplate['valuation'];
            }
          }
        });
      })
    },

    // 处理每个店铺下拉框
    initShipsTemplate(templateConfigMap) {
      const shipsTemplate = {};
      this.shopList.forEach(shop => {
        shipsTemplate[shop.id] = []
      });
      Object.keys(templateConfigMap).forEach(key=> {
        shipsTemplate[key] = [{
          id: templateConfigMap[key].templateId || '',
          name: templateConfigMap[key].templateName || '',
          valuation: templateConfigMap[key].valuation || null,
        }]
      })
      this.shipsTemplate = shipsTemplate;
    },
    // 获取配置
    async getConf() {
      const res = await getDistributionConfig({shopType: 'tb'});
      this.autoCropImageConfigList = res.autoCropImageConfigList ? res.autoCropImageConfigList : [];
      localStorage.setItem('autoCropImageConfigList',this.autoCropImageConfigList)
      // 上架设置
      // this.isOnshelf = this.self_form.isOnshelf ? this.self_form.isOnshelf : (res?.shelfState || 1);
      // 初始化运费模板配置
      this.initTemplateConfig(res?.templateList || []);
    },
    // 获取模板
    async getTemplateList(userId) {
      const list = await getTBTemplateList({userId: userId});
      if (list) {
          return list.map(ship => {
              return {
                  name: ship.name,
                  id: ship.templateId + '',
                  valuation: ship.valuation,
              }
          });
      }
      return [];
    },
    async changeSelect(isVisible, shop) {
      const shopId = shop.id;
      const options = this.shipsTemplate[shopId] || []
      if(!isVisible || options.length > 1 || (options.length === 1 && options[0]?.templateId === this.shipsValue[shopId])) return
      const list = await this.getTemplateList(shop.userId);
      const idx = list.findIndex(item => item.id == this.shipsValue[shopId]);
      if (idx === -1) {
        this.shipsValue[shopId] = '';
      }
      this.$set(this.shipsTemplate, shopId, list);
    },
    shipsChanged(value, shopId, userId) {
        this.templateConfigMap[shopId] = this.templateConfigMap[shopId] || {}
      if (!value) {
        Object.assign(this.templateConfigMap[shopId], {
          templateId: null,
          templateName: null,
          valuation: null
        });
      } else {
        const list = this.shipsTemplate[shopId];
        const idx = list.findIndex(item => item.id === this.shipsValue[shopId]);
        if (idx > -1) {
          const { valuation, name, id } = list[idx];
          Object.assign(this.templateConfigMap[shopId], {
            templateId: id,
            templateName: name,
            valuation
          });
        }
      }
    },
    fixedPriceGet(){
      const skuList = this.$refs.form.$refs?.saleProp?.[0]?.skuList || [];
      let priceList=[]
      skuList.forEach(item=>{
        if(!item.isGray) {
          priceList.push(item.skuPrice ? item.skuPrice - 0 : 0)
        }
      })
      this.priceList = priceList;
    },
  },
  mounted() {
  },
  destroyed() {
    this.clearTbInfo()
  }
};
</script>

<style lang="scss" scoped>
.title {
  padding: 10px;
  background: #f8f8f8;
  font-weight: 600;
}
.conf {
  margin-top: 20px;
}
.set-ship{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.shop-title {
  width: 130px;
  margin: 0 16px 0 10px;
  font-size: 12px;
  color: #606266;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.platform-info-edit-wrp {
  &.is-disabled {
    pointer-events: none;
    opacity: 0.6;
    * {
      pointer-events: none;
    }
  }
}
</style>